import React from "react";
import { Card } from "antd";
import DashboardLayout from "../LayoutNavbar/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../LayoutNavbar/Navbars/DashboardNavbar";
import FlightRiskPanel from "./FlightRiskPanel";

// Manager-only Flight Risk / Retention Insights (supervisor's direct reports).
const FlightRisk = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <Card
      title="Flight Risk / Retention Insights"
      className="card-professional"
      style={{ margin: 16 }}
    >
      <FlightRiskPanel mode="supervisor" />
    </Card>
  </DashboardLayout>
);

export default FlightRisk;
